"use client";

import { c as _c } from "react/compiler-runtime";
import ErrorComponent from "@/components/error/Error";
import styles from "@/styles/Home.module.scss";
import { extractErrorDetails } from "@/utils/error-extractor";
import { type FallbackProps } from "react-error-boundary";
export default function LayoutErrorFallback(t0) {
  const $ = _c(6);
  const {
    error,
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = error ? extractErrorDetails(error) : null;
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const errorDetails = t1;
  const digest = error && typeof error === "object" && "digest" in error ? (error as {
    digest?: string;
  }).digest : undefined;
  let t2;
  if ($[2] !== digest || $[3] !== errorDetails || $[4] !== resetErrorBoundary) {
    t2 = <main className={styles.main}><ErrorComponent stackTrace={errorDetails} digest={digest} onReset={resetErrorBoundary} /></main>;
    $[2] = digest;
    $[3] = errorDetails;
    $[4] = resetErrorBoundary;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}